export class StorageManager {
  static getLocale(): string {
    return window.localStorage.getItem('locale') || 'de';
  }

  static setLocale(locale: string): void {
    window.localStorage.setItem('locale', locale);
  }
}
